import ShowMeasurements from "./show-measurements";

export default function AthleteMeasurementsListPosition({ result }) {
  const getVideosForMeasurement = (measurementType) => {
    return Object.values(result.measurementVideosByType || {})
      .flat()
      .filter((video) => video.measurementType === measurementType)
      .map((video) => video.filePath);
  };

  return (
    <>
      {[
        { title: "Weight", value: `${result.weight} lbs`, key: "Weight" },
        {
          title: "Height",
          value: `${result.heightFt ?? 0}' ${result.heightIn ?? 0}''`,
          key: "Height",
        },
        {
          title: "Wingspan",
          value: `${result.wingSpanFt ?? 0}' ${result.wingSpanIn ?? 0}''`,
          key: "Wingspan",
        },
        { title: "Hand", value: `${result.hand ?? 0}''`, key: "Hand" },
        { title: "Foot", value: `${result.foot ?? 0}`, key: "Foot" },
      ].map((measurement) => (
        <ShowMeasurements
          userId={result.userId}
          key={measurement.key}
          title={measurement.title}
          value={measurement.value}
          isWeightMeasurement={measurement.key === "Weight"}
          score={
            result.measurementScores?.[`position${measurement.key}Score`] ?? 0
          }
          videoUrls={getVideosForMeasurement(measurement.key)}
        />
      ))}
    </>
  );
}
